import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Snackbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Formik, Form } from "formik";
import SendIcon from "@mui/icons-material/Send";
import Header from "../../components/Header";
import UserWidget from "../../components/OperadorWidget";
import { useSelector } from "react-redux";
import { tokens } from "../../theme";
import { dataGridStyles } from "../../styles/styles";
import { initialValuesContactos } from "../../data/initialValues"; //initialValuesDatosPersonales
import { validationSchemaContactos } from "../../data/validationSchemas"; //validationSchemaDatosPersonales
import { getDatosContactos, insertContactoOperador } from "../../services"; //updateDatosOperador

const DatosPersonales = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const datosOperador = useSelector((state) => state.dataEmpleado);
  const isSmallScreen = useMediaQuery("(max-width: 960px)");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [contactos, setContactos] = useState([]);

  const columns = [
    { field: "Nombre", headerName: "Nombre", flex: 1 },
    { field: "Cargo", headerName: "Cargo", flex: 1 },
    { field: "Telefono", headerName: "Teléfono", flex: 1 },
    { field: "Email", headerName: "Email", flex: 1 },
  ];

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  // const handleSubmitDatosPersonales = async (values) => {
  //   values.sistemaUsuario = datosOperador[0]?.Codigo;
  //   try {
  //     const datosOperador = await updateDatosOperador(values);
  //     if (datosOperador.ok) {
  //       setSnackbarSeverity("success");
  //       setSnackbarMessage("Datos de contacto agregados con éxito.");
  //       setOpenSnackbar(true);
  //       fetchContactos();
  //     } else {
  //       setSnackbarSeverity("error");
  //       setSnackbarMessage("Error en la solicitud");
  //       setOpenSnackbar(true);
  //     }
  //   } catch (error) {
  //     console.error("Error en la solicitud:", error);
  //     setSnackbarSeverity("error");
  //     setSnackbarMessage("Error en la solicitud");
  //     setOpenSnackbar(true);
  //   }
  // };

  const handleSubmitDatosContactos = async (values) => {
    values.sistemaUsuario = datosOperador[0]?.Codigo;
    try {
      const contactoOperador = await insertContactoOperador(values);
      if (contactoOperador.ok) {
        setSnackbarSeverity("success");
        setSnackbarMessage("Datos de contacto agregados con éxito.");
        setOpenSnackbar(true);
        fetchContactos();
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage("Error en la solicitud");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      setSnackbarSeverity("error");
      setSnackbarMessage("Error en la solicitud");
      setOpenSnackbar(true);
    }
  };

  const fetchContactos = useCallback(async () => {
    try {
      const datosContactos = await getDatosContactos(datosOperador[0]?.Codigo);
      setContactos(Array.isArray(datosContactos) ? datosContactos : []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [datosOperador]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchContactos();
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [fetchContactos]);

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="DATOS PERSONALES" subtitle="Actualiza tus contactos." />
      </Box>

      {/* Grid  */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: isSmallScreen ? "1fr" : "repeat(4, 1fr)",
          gap: 2,
          gridTemplateAreas: isSmallScreen
            ? `"header"
                 "main"
                 "sidebar"
                 "contacts"
                 "gridContacts"`
            : `"header header header header"
                 "main main sidebar sidebar"
                 "main main gridContacts gridContacts"`,
          alignItems: "stretch",
        }}
      >
        {/* Widget del Operador */}
        <Box
          sx={{
            gridArea: "main",
            boxShadow: 3,
            borderRadius: "10px",
            p: 4,
            bgcolor: colors.primary[400],
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box>
            <Typography variant="h5" fontWeight="bold" mb={2}>
              Información del Operador
            </Typography>
          </Box>
          <UserWidget
            codigoOperador={datosOperador[0]?.Codigo}
            nombreOperador={datosOperador[0]?.Operador}
            email={datosOperador[0]?.Email}
            direccion={datosOperador[0]?.Direccion}
            rtn={datosOperador[0]?.RTN}
            denominacion={datosOperador[0]?.Denominacion}
            telefono={datosOperador[0]?.Tel}
          />
        </Box>

        {/* Formulario de Datos Personales */}
        {/* <Box
          sx={{
            gridArea: "sidebar",
            p: 3,
            boxShadow: 3,
            borderRadius: "10px",
            bgcolor: colors.primary[400],
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <Formik
            initialValues={initialValuesDatosPersonales}
            validationSchema={validationSchemaDatosPersonales}
            onSubmit={handleSubmitDatosPersonales}
          >
            {({ values, handleChange, handleBlur, errors, touched }) => (
              <Form
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <Typography variant="h6" mb={2}>
                  Datos Personales
                </Typography>
                <Box
                  display="grid"
                  gap={2}
                  gridTemplateColumns="repeat(2, 1fr)"
                >
                  <TextField
                    fullWidth
                    label="Teléfono"
                    name="telefono"
                    variant="filled"
                    color="secondary"
                    value={values.telefono}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.telefono && Boolean(errors.telefono)}
                    helperText={touched.telefono && errors.telefono}
                  />
                  <TextField
                    fullWidth
                    label="Correo Electrónico"
                    name="correo"
                    type="email"
                    variant="filled"
                    color="secondary"
                    value={values.correo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.correo && Boolean(errors.correo)}
                    helperText={touched.correo && errors.correo}
                  />
                  <TextField
                    fullWidth
                    label="RTN"
                    name="rtn"
                    variant="filled"
                    color="secondary"
                    value={values.rtn}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.rtn && Boolean(errors.rtn)}
                    helperText={touched.rtn && errors.rtn}
                  />
                  <TextField
                    fullWidth
                    label="Identidad"
                    name="identidad"
                    variant="filled"
                    color="secondary"
                    value={values.identidad}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.identidad && Boolean(errors.identidad)}
                    helperText={touched.identidad && errors.identidad}
                  />
                  <TextField
                    fullWidth
                    label="Dirección"
                    name="direccion"
                    multiline
                    minRows={2}
                    variant="filled"
                    color="secondary"
                    value={values.direccion}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.direccion && Boolean(errors.direccion)}
                    helperText={touched.direccion && errors.direccion}
                    sx={{ gridColumn: "span 2" }}
                  />
                </Box>
                <Box display="flex" justifyContent="end" mt="auto">
                  <Button
                    type="submit"
                    color="secondary"
                    variant="contained"
                    endIcon={<SendIcon />}
                  >
                    <strong>Actualizar Datos</strong>
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </Box> */}

        {/* Formulario de Contactos */}
        <Box
          sx={{
            gridArea: "sidebar",
            p: 3,
            boxShadow: 3,
            borderRadius: "10px",
            bgcolor: colors.primary[400],
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            mb: 4,
          }}
        >
          <Formik
            initialValues={initialValuesContactos}
            validationSchema={validationSchemaContactos}
            onSubmit={handleSubmitDatosContactos}
          >
            {({ values, handleChange, handleBlur, errors, touched }) => (
              <Form style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography variant="h6" mb={2}>
                  Agregar Contacto
                </Typography>
                <Box display="grid" gap={2} gridTemplateColumns="repeat(2, 1fr)">
                  <TextField
                    fullWidth
                    label="Nombre"
                    name="nombreContacto"
                    variant="filled"
                    color="secondary"
                    value={values.nombreContacto}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.nombreContacto && Boolean(errors.nombreContacto)}
                    helperText={touched.nombreContacto && errors.nombreContacto}
                  />
                  <TextField
                    fullWidth
                    label="Identidad"
                    name="identidadContacto"
                    variant="filled"
                    color="secondary"
                    value={values.identidadContacto}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.identidadContacto && Boolean(errors.identidadContacto)}
                    helperText={touched.identidadContacto && errors.identidadContacto}
                  />
                  <TextField
                    fullWidth
                    label="Cargo"
                    name="cargo"
                    variant="filled"
                    color="secondary"
                    value={values.cargo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.cargo && Boolean(errors.cargo)}
                    helperText={touched.cargo && errors.cargo}
                  />
                  <TextField
                    fullWidth
                    label="Correo Electrónico"
                    name="emailContacto"
                    type="email"
                    variant="filled"
                    color="secondary"
                    value={values.emailContacto}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.emailContacto && Boolean(errors.emailContacto)}
                    helperText={touched.emailContacto && errors.emailContacto}
                  />
                  <TextField
                    fullWidth
                    label="Teléfono"
                    name="telefonoContacto"
                    variant="filled"
                    color="secondary"
                    value={values.telefonoContacto}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.telefonoContacto && Boolean(errors.telefonoContacto)}
                    helperText={touched.telefonoContacto && errors.telefonoContacto}
                  />
                  <TextField
                    fullWidth
                    label="Dirección"
                    name="direccionContacto"
                    multiline
                    minRows={2}
                    variant="filled"
                    color="secondary"
                    value={values.direccionContacto}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.direccionContacto && Boolean(errors.direccionContacto)}
                    helperText={touched.direccionContacto && errors.direccionContacto}
                    sx={{ gridColumn: "span 2" }}
                  />
                </Box>
                <Box display="flex" justifyContent="end" mt="15px">
                  <Button type="submit" color="secondary" variant="contained" endIcon={<SendIcon />}>
                    <strong>Agregar Contacto</strong>
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>

        {/* Tabla de Contactos */}
        <Box
          sx={{
            gridArea: "gridContacts",
            p: 3,
            boxShadow: 3,
            borderRadius: "10px",
            bgcolor: colors.primary[400],
            mb: 4,
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" mb={2}>
            Contactos
          </Typography>
          <DataGrid
            rows={contactos}
            columns={columns}
            autoHeight
            pageSize={5}
            sx={{
              ...dataGridStyles(colors),
            }}
          />
        </Box>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default DatosPersonales;
